import React from 'react';

import { Grid, Section } from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';

import {
  loadUsers,
  loadActiveUsers,
  loadCountries,
  loadTimeZones,
} from 'scenes/PartnerCompanies/sources/fields';

import {
  NAME,
  OWNER,
  ADDRESS,
  STREET_ADDRESS,
  STREET_ADDRESS_2,
  CITY,
  REGION,
  POSTAL_CODE,
  COUNTRY,
  TIME_ZONE,
} from './constants';
import { PartnerCompanyFormValidationSchema } from './schemas';

const PartnerCompanyForm = withForm({
  validationSchema: PartnerCompanyFormValidationSchema,
  enableReinitialize: true,
})(({
  children,
  title,
  subTitle,
  loading,
  onClose,
  onExited,
  open,
  isEdit,
  entityId,
}) => {
  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      size={'lg'}
    >
      <SidePageV2.Title title={title} subTitle={subTitle} entityId={entityId} />
      <SidePageV2.NewBody>
        <Section title={'General'}>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <FormField.TextField
                label={'Name'}
                name={NAME}
                helper={'Commercial or brand name'}
                padding={0}
                required={true}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.Select
                label={'Owner'}
                name={OWNER}
                source={isEdit ? loadUsers : loadActiveUsers}
                lazy={true}
                padding={0}
                required={true}
              />
            </Grid>
          </Grid>
        </Section>
        <Section title={'Address'}>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <FormField.TextField
                label={'Address line 1'}
                name={`${ADDRESS}.${STREET_ADDRESS}`}
                helper={'Street address, P.O. box, company name, c/o'}
                padding={0}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.TextField
                label={'Address line 2'}
                name={`${ADDRESS}.${STREET_ADDRESS_2}`}
                helper={'Apartment, suite, unit, building, floor, etc.'}
                padding={0}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.TextField
                label={'City'}
                name={`${ADDRESS}.${CITY}`}
                padding={0}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.TextField
                label={'State / Province / Region'}
                name={`${ADDRESS}.${REGION}`}
                padding={0}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.TextField
                label={'Zip / Postal code'}
                name={`${ADDRESS}.${POSTAL_CODE}`}
                padding={0}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.Select
                label={'Country'}
                name={`${ADDRESS}.${COUNTRY}`}
                source={loadCountries}
                lazy={true}
                padding={0}
                required={true}
              />
            </Grid>
            <Grid item xs={4}>
              <FormField.Select
                label={'Time zone'}
                name={TIME_ZONE}
                source={loadTimeZones}
                lazy={true}
                padding={0}
              />
            </Grid>
          </Grid>
        </Section>
      </SidePageV2.NewBody>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
      {children}
    </SidePageV2>
  );
});

export default PartnerCompanyForm;
